// API URLs
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://oracledca.com/api';

// Authentication
export const TOKEN_STORAGE_KEY = 'oracleDCA_token';
export const REFRESH_TOKEN_STORAGE_KEY = 'oracleDCA_refreshToken';
export const AUTH_USER_STORAGE_KEY = 'oracleDCA_user';

// Notification Settings
export const NOTIFICATION_SETTINGS = {
  // Portfolio Performance Thresholds
  PORTFOLIO_PERFORMANCE_THRESHOLD: 5, // 5% gain/loss threshold
  
  // Bitcoin Price Psychological Levels
  BITCOIN_PSYCHOLOGICAL_LEVELS: [50000, 60000, 70000, 80000, 90000, 100000, 110000, 120000, 150000, 200000],
  
  // RSI Psychological Levels
  RSI_PSYCHOLOGICAL_LEVELS: [20, 30, 40, 50, 60, 70, 80, 90],
  RSI_LEVEL_TOLERANCE: 2, // Margem de tolerância para níveis de RSI
  
  // Frequency Controls
  FREQUENCIES: {
    DAILY: 1,
    WEEKLY: 7,
    MONTHLY: 30
  }
};

// RSI Ranges
export const RSI_RANGES = {
  OVERSOLD: { min: 0, max: 30, color: 'text-green-600' },
  RECOVERY_THRESHOLD: { min: 30, max: 40, color: 'text-green-500' },
  NEUTRAL_LOW: { min: 40, max: 50, color: 'text-blue-500' },
  NEUTRAL_HIGH: { min: 50, max: 60, color: 'text-blue-600' },
  MOMENTUM_BUILDUP: { min: 60, max: 70, color: 'text-yellow-500' },
  OVERBOUGHT_LOW: { min: 70, max: 80, color: 'text-orange-500' },
  OVERBOUGHT_HIGH: { min: 80, max: 100, color: 'text-red-500' }
};

// Regimes
export const REGIMES = {
  BULL: {
    id: 'bull',
    name: 'Bull Market',
    emoji: '🚀',
    color: 'bg-green-100 border-green-500 text-green-800',
    description: 'Mercado em alta, caracterizado por preços em crescimento e otimismo.'
  },
  BEAR: {
    id: 'bear',
    name: 'Bear Market',
    emoji: '🐻',
    color: 'bg-red-100 border-red-500 text-red-800',
    description: 'Mercado em baixa, caracterizado por preços em queda e pessimismo.'
  },
  TRANSITION: {
    id: 'transition',
    name: 'Transition',
    emoji: '🔄',
    color: 'bg-yellow-100 border-yellow-500 text-yellow-800',
    description: 'Mercado em transição, período de incerteza entre regimes.'
  },
  PRE_BULL: {
    id: 'pre_bull',
    name: 'Pre-Bull',
    emoji: '🌱',
    color: 'bg-blue-100 border-blue-500 text-blue-800',
    description: 'Fase inicial de recuperação, indicando potencial início de mercado em alta.'
  }
};

// Transaction Types
export const TRANSACTION_TYPES = {
  BUY: {
    id: 'buy',
    name: 'Buy',
    color: 'text-green-600',
    icon: 'ArrowDownIcon'
  },
  SELL: {
    id: 'sell',
    name: 'Sell',
    color: 'text-red-600',
    icon: 'ArrowUpIcon'
  },
  REINVESTMENT: {
    id: 'reinvestment',
    name: 'Reinvestment',
    color: 'text-blue-600',
    icon: 'ArrowPathIcon'
  }
};

// Menu Items
export const MENU_ITEMS = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    icon: 'HomeIcon'
  },
  {
    title: 'Portfolio',
    path: '/portfolio',
    icon: 'ChartPieIcon'
  },
  {
    title: 'Weekly Trade',
    path: '/weekly-trade',
    icon: 'ArrowTrendingUpIcon'
  },
  {
    title: 'Transactions',
    path: '/transactions',
    icon: 'ClipboardDocumentListIcon'
  },
  {
    title: 'Manual Transaction',
    path: '/transactions/new',
    icon: 'PlusCircleIcon'
  },
  {
    title: 'Settings',
    path: '/settings',
    icon: 'Cog6ToothIcon'
  }
]; 